import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { bgFileTheme, classNames } from '../../../containers/Pages/Edd/EddUtils';

const CustomFile = memo(props => {
  const { fileType } = props;
  const bgGcolor = bgFileTheme[fileType.toLowerCase()];

  return (
    <div className="relative">
      <img
        className="w-[30px] h-[30px] max-w-[30px] max-h-[30px]"
        src="/assets/images/icons/file-spreadsheet.svg"
        alt="File"
      />

      <p
        className={classNames(
          'absolute bottom-2 font-bold z-30 left-1  text-white h-3 w-3 flex items-center justify-center text-xs leading-none ',
          `${bgGcolor}`,
        )}
      >
        {fileType.toLowerCase()[0]}
      </p>
    </div>
  );
});

CustomFile.propTypes = {
  fileType: PropTypes.string,
};

export default CustomFile;
